import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { RouteErrorFallback } from '@/components/ErrorBoundary'
import { Pencil, Loader2 } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import {
  PageContainer,
  PageCard,
  PageHeader,
  PageHeaderContent,
  PageHeaderTitle,
  PageHeaderHeading,
  PageHeaderDescription,
  PageContent
} from '@/components/ui/page'
import { useOrganization } from '@/hooks/useOrganization'
import { OrganizationNameEditDialog } from '@/components/organization/OrganizationNameEditDialog'

export const Route = createFileRoute('/organization')({
  component: Organization,
  errorComponent: RouteErrorFallback,
})

function Organization() {
  const [editDialogOpen, setEditDialogOpen] = useState(false)
  const { data: organization, isLoading, error } = useOrganization()

  return (
    <>
      <PageContainer>
        <PageCard>
          <PageHeader>
            <PageHeaderContent>
              <PageHeaderTitle>
                <PageHeaderHeading>Organisation</PageHeaderHeading>
                <PageHeaderDescription>Verwalten Sie Ihre Organisationseinstellungen und -details</PageHeaderDescription>
              </PageHeaderTitle>
            </PageHeaderContent>
          </PageHeader>
          <PageContent className="p-6 overflow-auto">
            <Card>
              <CardHeader>
                <CardTitle>Organisationsdetails</CardTitle>
                <CardDescription>Verwalten Sie Ihre Organisationseinstellungen</CardDescription>
              </CardHeader>
              <CardContent>
                {isLoading ? (
                  <div className="space-y-4">
                    <div>
                      <h3 className="text-sm font-medium mb-1">Organisationsname</h3>
                      <Skeleton className="h-5 w-48" />
                    </div>
                    <div>
                      <h3 className="text-sm font-medium mb-1">Mitglieder</h3>
                      <Skeleton className="h-5 w-32" />
                    </div>
                  </div>
                ) : error ? (
                  <div className="text-sm text-destructive">
                    Fehler beim Laden der Organisationsdaten. Bitte versuchen Sie es später erneut.
                  </div>
                ) : (
                  <div className="space-y-4">
                    <div>
                      <div className="flex items-center justify-between">
                        <h3 className="text-sm font-medium mb-1">Organisationsname</h3>
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => setEditDialogOpen(true)}
                          className="h-11 w-11 p-0 md:h-8 md:w-8"
                        >
                          <Pencil className="h-4 w-4" />
                          <span className="sr-only">Organisationsname bearbeiten</span>
                        </Button>
                      </div>
                      <p className="text-sm text-muted-foreground">
                        {organization?.name || 'Kein Name gesetzt'}
                      </p>
                    </div>
                    <div>
                      <h3 className="text-sm font-medium mb-1">Mitglieder</h3>
                      <p className="text-sm text-muted-foreground">1 Mitglied</p>
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>
          </PageContent>
        </PageCard>
      </PageContainer>

      {organization && (
        <OrganizationNameEditDialog
          open={editDialogOpen}
          onOpenChange={setEditDialogOpen}
          currentName={organization.name}
        />
      )}
    </>
  )
}